
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { ValidationProvider } from 'vee-validate';
import InfoBanner from '@/components/shared/suites/InfoBanner.vue';
import TextField from '@/components/shared/TextField.vue';
import DeliveryFeeRanges from './FeeRanges.vue';
import '@/validation-rules';

@Component<FeeMode>({
	components: {
		ValidationProvider,
		InfoBanner,
		TextField,
		DeliveryFeeRanges
	}
})
export default class FeeMode extends Vue {
	@Prop({ type: String, default: 'fixed' }) private feeMode!: 'fixed' | 'custom';
	@Prop({ type: String, default: '' }) private charge!: string;
	@Prop({ type: Boolean, default: true }) private chargeTypeIsDollar!: boolean;
	@Prop({ type: Array, default: () => [] }) private feeRanges!: DeliveryFeeRange[];
	@Prop({ type: Number, default: 0 }) private maxRadius!: number;
	@Getter('getCurrencySymbol', { namespace: 'auth' }) private currencySymbol!: string;
	@Watch('maxRadius')
	private onMaxRadiusChanged(): void {
		if (this.maxRadius <= 0 && this.feeRanges.length) {
			this.$emit('update:feeRanges', []);
		}
	}

	private get selectedFeeMode(): 'fixed' | 'custom' {
		return this.feeMode;
	}

	private set selectedFeeMode(val: 'fixed' | 'custom') {
		this.$emit('update:feeMode', val);

		if (val === 'fixed') {
			this.$emit('update:feeRanges', []);
		}
		else {
			this.$emit('update:charge', '');
		}
	}

	private get chargePrefix(): string {
		return this.chargeTypeIsDollar ? this.currencySymbol : '%';
	}

	/**
	 * Validation rules for charge input, adding integer rule for percentage mode
	 *
	 * @return {string}
	 */
	private get chargeValidationRules(): string {
		return this.chargeTypeIsDollar ? 'required' : 'required|max_value:100|integer';
	}
}
